import { SummaryMetricInput } from "reports/utils/metricUtils";
import ReportHeader, { getEosDateStringWithGeAndLt } from "./ReportHeader";
import {
  useGeAndLtFromUrl,
  useProcessGroupNameAndMachemetryIds,
} from "./reportUtils";
import SkuCountTable from "./SkuCountTable";
import { useParams } from "react-router";
import { ReportParams } from "reports/types";

export default function SkuAndMetricReport({
  title,
  skuSummaryMetrics,
}: {
  title?: string;
  skuSummaryMetrics?: SummaryMetricInput[];
}) {
  const { ckey: tenant } = useParams() as ReportParams;
  const { machemetryIds } = useProcessGroupNameAndMachemetryIds({});
  const { ge, lt } = useGeAndLtFromUrl();
  const dateString = getEosDateStringWithGeAndLt(ge, lt);

  return (
    <>
      <ReportHeader
        title={title ?? tenant.toUpperCase()}
        subheader="SKU Count"
        dateString={dateString}
      />
      <SkuCountTable
        skuSummaryMetrics={skuSummaryMetrics}
        machemetryIds={machemetryIds}
      />
    </>
  );
}
